import { useEffect, useRef, useState } from "react";

/**
 * Sentry's ErrorBoundary has no built-in "clear the fallback once the user
 * navigates away from the crashed route" behavior. Keying the boundary by
 * the route itself would force a full remount on *every* navigation (the
 * whole subtree unmounts/remounts as if the page refreshed), not just after
 * a crash. This only bumps the key once an error has actually been caught,
 * so a normal route change never touches the boundary.
 */
export function useResettableErrorBoundaryKey(routeKey) {
  const [boundaryKey, setBoundaryKey] = useState(0);
  const hadErrorRef = useRef(false);

  useEffect(() => {
    if (hadErrorRef.current) {
      hadErrorRef.current = false;
      setBoundaryKey((k) => k + 1);
    }
  }, [routeKey]);

  const onError = () => {
    hadErrorRef.current = true;
  };

  return { boundaryKey, onError };
}
